export default __webpack_public_path__ + "static/media/magic-c.bd748c9f.png";